<mat-toolbar class="itinerary-toolbar mat-elevation-z2" fxLayout="row" fxLayoutAlign="start center">
  <button mat-icon-button (click)="snav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <span class="itinerary-status" [ngStyle]="{
      'background-color': itinerary.status | itineraryStatusColor
    }">{{ itinerary.status | itineraryStatusLabel }}
  </span>
  <h3 class="itinerary-title" fxFlex>{{ itinerary.title }}</h3>
  <button mat-icon-button (click)="rearrangeDays()" matTooltip="Riordina giorni"
    *ngIf="!itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)">
    <mat-icon>low_priority</mat-icon>
  </button>
</mat-toolbar>
<mat-sidenav-container class="itinerary-sidenav-container">
  <mat-sidenav #snav [opened]="mobileQuery.matches ? false : true" [mode]="mobileQuery.matches ? 'over' : 'side'"
    class="mat-elevation-z2" style="min-width: 225px">
    <div fxLayout="column" fxFlex>
      <mat-nav-list style="padding-top: 0" fxLayout="column" fxFlex style="overflow: auto">
        <ng-container *ngIf="isCurrentUserAdmin()">
          <a mat-list-item class="mat-typography" [routerLink]="['./settings']" routerLinkActive="active">
            <mat-icon matListIcon>settings</mat-icon>
            <h4 mat-line>Impostazioni</h4>
          </a>
          <mat-divider></mat-divider>
        </ng-container>
        <a mat-list-item class="mat-typography" [routerLink]="['./info']" routerLinkActive="active">
          <mat-icon matListIcon>info</mat-icon>
          <h4 mat-line>Info Generali</h4>
        </a>
        <a mat-list-item class="mat-typography" [routerLink]="['./customer-requests']" routerLinkActive="active">
          <mat-icon matListIcon>assignment</mat-icon>
          <h4 mat-line>Richieste Cliente</h4>
        </a>
        <a mat-list-item class="mat-typography" [routerLink]="['./reservations']" routerLinkActive="active">
          <mat-icon matListIcon>local_play</mat-icon>
          <h4 mat-line>Prenotazioni</h4>
        </a>
        <ng-container *ngIf="itinerary.days?.length > 0">
          <mat-divider></mat-divider>
          <a mat-list-item class="mat-typography" *ngFor="let day of itinerary.days; let i = index"
            [routerLink]="['./day', i + 1]" routerLinkActive="active">
            <mat-icon matListIcon>map</mat-icon>
            <h4 mat-line>Giorno {{ i + 1 }}</h4>
            <p matLine>
              <small>{{ day.date?.toDate() | date: "d MMMM, EEEE" }}</small>
            </p>
          </a>
          <mat-divider></mat-divider>
        </ng-container>
        <a mat-list-item class="mat-typography" [routerLink]="['./expenses']" routerLinkActive="active">
          <mat-icon matListIcon>receipt</mat-icon>
          <h4 mat-line>Spese</h4>
        </a>
        <mat-divider></mat-divider>
        <a mat-list-item class="mat-typography" href="javascript:void(0)" (click)="downloadGpx()">
          <mat-icon matListIcon>explore</mat-icon>
          <h4 mat-line>Scarica Mappa</h4>
          <p matLine><small>File in formato GPX</small></p>
        </a>
        <ng-container *ngIf="isCurrentUserAdmin()">
          <mat-divider></mat-divider>
          <a mat-list-item class="mat-typography" [routerLink]="['./snapshots']" routerLinkActive="active">
            <mat-icon matListIcon>history</mat-icon>
            <h4 mat-line>Snapshots</h4>
          </a>
        </ng-container>

      </mat-nav-list>
      <mat-nav-list style="padding-top: 0" fxLayout="column">
        <mat-divider></mat-divider>
        <a *ngIf="
            itinerary.status === 'TODO' || itinerary.status === 'IN_PROGRESS'
          " mat-list-item class="mat-typography" [routerLink]="['./preview']" routerLinkActive="active">
          <mat-icon matListIcon>book</mat-icon>
          <h4 mat-line>Anteprima</h4>
        </a>
        <a *ngIf="
            itinerary.status === 'IN_REVIEW' || itinerary.status === 'DONE'
          " mat-list-item class="mat-typography" href="{{ itinerary.link.longUrl }}" target="_blank">
          <mat-icon matListIcon>file_download</mat-icon>
          <h4 mat-line>Apri PDF</h4>
        </a>
        <mat-divider></mat-divider>
        <div class="sidenav-buttons-container" fxLayout="column">
          <button *ngIf="
              itinerary.status === 'TODO' || itinerary.status === 'IN_PROGRESS'
            " class="sidenav-button" mat-raised-button color="primary"
            (click)="itineraryWorkflowService.save(itinerary)">
            Salva
          </button>
          <button *ngIf="
              itinerary.status === 'TODO' || itinerary.status === 'IN_PROGRESS'
            " class="sidenav-button sidenav-primary-button" mat-raised-button color="primary"
            [routerLink]="['./review']">
            Avvia Revisione
          </button>
          <button *ngIf="itinerary.status === 'IN_REVIEW' && isCurrentUserAdmin()"
            class="sidenav-button sidenav-primary-button" mat-raised-button color="primary"
            (click)="itineraryWorkflowService.rimodifica(itinerary)">
            Modifica
          </button>
          <button *ngIf="itinerary.status === 'IN_REVIEW' && isCurrentUserAdmin()"
            class="sidenav-button sidenav-primary-button" mat-raised-button color="primary"
            (click)="itineraryWorkflowService.consegna(itinerary)">
            Consegna
          </button>
          <button *ngIf="itinerary.status === 'DONE' && isCurrentUserAdmin()"
            class="sidenav-button sidenav-not-important-button" mat-raised-button color="primary"
            (click)="itineraryWorkflowService.rimodifica(itinerary)">
            Modifica
          </button>
        </div>
      </mat-nav-list>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="itinerary-sidenav-content">
    <form name="itinerary-form">
      <fieldset [disabled]="
          itineraryService.isItineraryReadOnlyForCurrentUser(itinerary)
        ">
        <div class="itinerary-sidenav-content-outlet-wrapper">
          <router-outlet></router-outlet>
        </div>
      </fieldset>
    </form>
  </mat-sidenav-content>
</mat-sidenav-container>